// src/store/slices/tenantSlice.js
import { createSlice } from "@reduxjs/toolkit";

const LS_PAN_ID = "pan_id";
const LS_PAN_IDS = "pan_ids";
const LS_PAN_ACTIVE = "pan_id_active";
const LS_PAN_NAME = "pan_name";

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const toNumArray = (a) =>
  (Array.isArray(a) ? a : [])
    .map((x) => Number(x))
    .filter((n) => Number.isFinite(n) && n > 0);

const initialState = {
  pan_id: toNum(localStorage.getItem(LS_PAN_ID)),
  pan_ids: toNumArray(JSON.parse(localStorage.getItem(LS_PAN_IDS) || "[]")),
  pan_id_active: toNum(localStorage.getItem(LS_PAN_ACTIVE)),
  pan_name: localStorage.getItem(LS_PAN_NAME) || "Select Panchayath",
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenant(state, { payload }) {
      const pan_ids = toNumArray(payload?.pan_ids || []);
      const pan_id = toNum(payload?.pan_id);
      const pan_id_active = toNum(payload?.pan_id_active);
      const pan_name = String(payload?.pan_name || "").trim();

      // 1) Clear / none selected
      if (!pan_ids.length && !pan_id && !pan_id_active) {
        state.pan_id = 0;
        state.pan_ids = [];
        state.pan_id_active = 0;
        state.pan_name = "Select Panchayath";
      }
      // 2) ALL selected (multi)
      else if (pan_ids.length > 1) {
        state.pan_ids = pan_ids;
        state.pan_id = 0;
        state.pan_id_active = 0; // ✅ ALL mode
        state.pan_name = pan_name || "All Panchayaths";
      }
      // 3) Single selected
      else {
        const id = pan_id_active || pan_id || pan_ids[0] || 0;
        state.pan_id = id;
        state.pan_ids = id ? [id] : [];
        state.pan_id_active = id;
        state.pan_name = pan_name || state.pan_name || "Select Panchayath";
      }

      localStorage.setItem(LS_PAN_ID, String(state.pan_id));
      localStorage.setItem(LS_PAN_IDS, JSON.stringify(state.pan_ids));
      localStorage.setItem(LS_PAN_ACTIVE, String(state.pan_id_active));
      localStorage.setItem(LS_PAN_NAME, String(state.pan_name));
    },

    clearTenant(state) {
      state.pan_id = 0;
      state.pan_ids = [];
      state.pan_id_active = 0;
      state.pan_name = "Select Panchayath";

      localStorage.removeItem(LS_PAN_ID);
      localStorage.removeItem(LS_PAN_IDS);
      localStorage.removeItem(LS_PAN_ACTIVE);
      localStorage.removeItem(LS_PAN_NAME);
    },
  },
});

export const { setTenant, clearTenant } = tenantSlice.actions;
export default tenantSlice.reducer;
